import { useMemo } from "react"
import useFetch from "../../hooks/useFetch"
import { api } from "../../services/api"
import { useTranslation } from "react-i18next"

const ElegirTag = ({ setTag, setHasImages = null, alAzarCallback = null }) => {
  const { url, opt } = useMemo(() => api.tags.readAll({}), []),
    [tags, isPending, err] = useFetch({ url, opt })

  const { t } = useTranslation()

  if (isPending && !err)
    return (
      <div className="row my-5 py-5">
        <center>{t(`ui.btns.loading`)}...</center>
      </div>
    )

  return (
    <>
      <div className="title">{t(`ui.games.headers.choose_a_category`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="row">
          {tags.entries
            .filter((t) => t.visible)
            .map((tag, ix) => (
              <div key={ix} className="col-lg-4 col-6 py-1">
                <div
                  className="box category"
                  onClick={() => {
                    setTag(tag.name)
                    if (setHasImages != null) setHasImages(tag.images)
                  }}>
                  <span>{tag.name}</span>
                </div>
              </div>
            ))}

          {alAzarCallback && (
            <>
              <div className="col-lg-4 col-6 py-1">
                <div className="box category azaroso" onClick={alAzarCallback}>
                  <span>{t(`ui.games.btns.random`)}</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export { ElegirTag }
